// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__3OJlO","spin":"Loader_spin__3agwU","loader_container":"Loader_loader_container__x-Kyb"};